import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyNavigation } from '../lib/embedHost';

/**
 * Emits a `studio:navigation` postMessage to the parent whenever the
 * internal react-router route changes. Skips the initial mount to avoid
 * clobbering the parent's URL with Studio's boot-time default route.
 */
export const NavigationSync = (): null => {
  const { pathname, search, hash } = useLocation();
  const skipRef = useRef(true);

  useEffect(() => {
    if (skipRef.current) {
      skipRef.current = false;
      return;
    }
    notifyNavigation(pathname, search + hash);
  }, [pathname, search, hash]);

  return null;
};
